import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

const tz = 'America/New_York'

export const convertDateFormat = (originalDate: string, outputFormat: string, entryFormat?: string | string[]) => {
	if (entryFormat) {
		return dayjs(originalDate, entryFormat).format(outputFormat)
	}
	return dayjs.utc(originalDate).format(outputFormat)
}

export const convertUTCTimezone = (date: string) => dayjs(date).tz(tz)

export const convertDateFormatAndTz = (originalDate: string, outputFormat: string, entryFormat?: string) => {
	const toTimezone = convertUTCTimezone(originalDate)

	if (entryFormat) {
		return dayjs(toTimezone, entryFormat).format(outputFormat)
	}
	return dayjs(toTimezone).format(outputFormat)
}

export const difference = (date1: Date, date2?: Date) => {
	const date1Obj = dayjs(date1)
	const date2Obj = date2 ? dayjs(date2) : dayjs()

	const year = date1Obj.diff(date2Obj, 'year')
	const month = date1Obj.diff(date2Obj, 'month')
	const day = date1Obj.diff(date2Obj, 'day')
	const hour = date1Obj.diff(date2Obj, 'hour')
	const minute = date1Obj.diff(date2Obj, 'minute')
	const second = date1Obj.diff(date2Obj, 'second')

	return {
		year,
		month,
		day,
		hour,
		minute,
		second,
	}
}

export const calculateInterval = (entryDate: Date, hourOutput?: string, minOutput?: string) => {
	const currentDate = dayjs()
	const date1 = convertUTCTimezone(entryDate as unknown as string)
	const hours = date1.diff(currentDate, 'hours')

	if (hours > 0) {
		return { time: hours as number, intervalString: `${hours}${hourOutput ? hourOutput : 'h'}` as string }
	} else {
		const minutes = date1.diff(currentDate, 'minute')
		return { time: minutes as number, intervalString: `${minutes}${minOutput ? minOutput : 'min'}` as string }
	}
}

export const calculateDaysInterval = (entryDate: Date) => {
	const currentDate = dayjs()
	const date1 = dayjs(convertUTCTimezone(entryDate as unknown as string))
	const days = date1.diff(currentDate, 'day')

	return days
}

export const adjustForUTCOffset = (d: Date) => {
	const date = dayjs(d)
	return date.utc()
}

export const calculateAdulthood = (birthday: Date, initialDate: Date) => {
	const { year } = difference(initialDate, birthday)
	return year > 12 ? 'Adult' : 'Child'
}

export default dayjs
